<template>
  <div class="contact-info">
    <FormSection
      :title="$t('PUBLISHER_ACCOUNT.CONTACT_INFO')"
      :description="$t('PUBLISHER_ACCOUNT.CONTACT_INFO_DESC.PHONE')"
      :has-edit="hasEditPermission"
      :is-edit-mode="editable.phoneNumber"
      class="contact-info__phone-section"
      @edit="editable.phoneNumber = true"
    >
      <Card :hide-overflow="false">
        <PhoneNumberForm
          v-show="editable.phoneNumber"
          :phone="userData.phone"
          @data-updated="afterUpdatePhoneNumber"
          @cancel-edit="editable.phoneNumber = false"
        />
        <PublisherInfoList
          v-show="!editable.phoneNumber"
          :data="phoneDataList"
        />
      </Card>
    </FormSection>

    <FormSection
      :description="$t('PUBLISHER_ACCOUNT.CONTACT_INFO_DESC')"
      :has-edit="hasEditPermission"
      :is-edit-mode="editable.contactInfo"
      @edit="editable.contactInfo = true"
    >
      <Card :hide-overflow="false">
        <ContactInfoForm
          v-show="editable.contactInfo"
          :user-data="userData"
          @data-updated="afterUpdateContactInfo"
          @cancel-edit="editable.contactInfo = false"
        />

        <PublisherInfoList
          v-show="!editable.contactInfo"
          :data="contactDataList"
        />
      </Card>
    </FormSection>
  </div>
</template>

<script>
import provinces from '@/utils/provinces';
import lang from '@/mixins/lang';

import FormSection from '@@/common/layout/FormSection';
import Card from '@@/common/Card';
import PublisherInfoList from '../PublisherInfoList';
import ContactInfoForm from './ContactInfoForm';
import PhoneNumberForm from './PhoneNumberForm';

export default {
  name: 'ContactInfo',

  components: {
    FormSection,
    Card,
    PublisherInfoList,
    ContactInfoForm,
    PhoneNumberForm,
  },

  mixins: [lang],

  props: {
    userData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      editable: {
        contactInfo: false,
        phoneNumber: false,
      },
    };
  },

  computed: {
    hasEditPermission() {
      return this.$auth.check(['publisher', 'changeFinanceInfo']);
    },

    userProvince() {
      const { province } = this.userData;

      if (!province || this.lang !== 'fa') {
        return province;
      }

      const p = provinces.find(p => p.slug === province);
      return p && p.title;
    },

    contactDataList() {
      return [
        {
          key: 'postal_code',
          title: this.$t('POSTAL_CODE'),
          value: this.userData.postal_code,
        },
        {
          key: 'province',
          title: this.$t('PROVINCE'),
          value: this.userProvince,
        },
        {
          key: 'city',
          title: this.$t('CITY'),
          value: this.userData.city || '-',
        },
        {
          key: 'address',
          title: this.$t('ADDRESS'),
          value: this.userData.address,
        },
      ];
    },

    phoneDataList() {
      return [
        {
          key: 'phone',
          title: this.$t('PHONE'),
          value: this.userData.phone,
        },
      ];
    },
  },

  methods: {
    afterUpdateContactInfo(updatedData) {
      this.editable.contactInfo = false;
      this.$emit('data-updated', { ...this.userData, ...updatedData });
    },

    afterUpdatePhoneNumber(phone) {
      this.editable.phoneNumber = false;
      this.$emit('data-updated', { ...this.userData, phone });
    },
  },
};
</script>

<style lang="scss">
.contact-info {
  &__phone-section {
    margin-bottom: $global-margin * 2;
  }
}
</style>
